const Error = () => {
  return (
    <>
      <link rel="stylesheet" href="/assets/css/master-error-404.css"></link>
      <main>
        {/* error area start  */}
        <section className="error-area">
          <div className="container">
            <div className="error-area-inner section-spacing">
              <div className="section-content">
                <div className="shape-1">
                  <img
                    className="show-light"
                    src="/assets/imgs/error/img-s-88.webp"
                    alt="shape" loading="lazy" decoding="async" />
                  <img
                    className="show-dark"
                    src="/assets/imgs/error/img-s-88-light.webp"
                    alt="shape" loading="lazy" decoding="async" />
                </div>
                <div className="error-shape has_fade_anim">
                  <img
                    className="show-light"
                    src="/assets/imgs/error/img-s-87.webp"
                    alt="shape" loading="lazy" decoding="async" />
                  <img
                    className="show-dark"
                    src="/assets/imgs/error/img-s-87-light.webp"
                    alt="shape" loading="lazy" decoding="async" />
                </div>
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h1
                      className="section-title has_fade_anim"
                      data-delay="0.30"
                    >
                      Ooop! Error page!
                    </h1>
                  </div>
                </div>
                <div className="text-wrapper">
                  <p className="text has_fade_anim" data-delay="0.45">
                    Hmm... we couldn’t trace the page you’re seeking.<br />
                    It may have been archived, renamed, or simply never created.
                  </p>
                </div>
                <div className="btn-wrapper has_fade_anim" data-delay="0.60">
                  <a href="/" className="wc-btn wc-btn-primary btn-text-flip">
                    {" "}
                    <span data-text="Back to home">Back to home</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* error area end  */}
      </main>
    </>
  );
};
export default Error;
